import { useMemo } from 'react'
import {
  DEPARTAMENTOS_CARGOS_USUARIOS_QUERY,
  DEPARTAMENTOS_COMUNICADOS_QUERY
} from '../data/departamentos'
import {
  DepartamentosCargosUsuariosQuery,
  DepartamentosComunicadosQuery
} from '@/core/types/graphql'
import { OptionSelect } from '../utils/types'
import { useQuery } from '@tanstack/react-query'
import { request } from '../utils/request'

export interface DepartamentoOption extends OptionSelect {
  sigla: string
  assinatura?: string
}

export const useDepartamentosCargosUsuarios = () => {
  const {
    data: { departamentosCargosUsuarios = [] } = {},
    isLoading: loading
  } = useQuery({
    queryKey: ['departamentosCargosUsuarios'],
    queryFn: async () =>
      await request<DepartamentosCargosUsuariosQuery>(
        DEPARTAMENTOS_CARGOS_USUARIOS_QUERY
      )
  })

  const departamentosOptions = useMemo(
    () =>
      departamentosCargosUsuarios?.map(it => ({
        label:
          it?.sigla && it.sigla.length > 0
            ? `[${it?.sigla}] ${it?.nome}`
            : it?.nome,
        value: it?.id,
        sigla: it?.sigla,
        assinatura: it?.assinatura
      })) as DepartamentoOption[],
    [departamentosCargosUsuarios]
  )

  const departamentos = useMemo(
    () => departamentosCargosUsuarios,
    [departamentosCargosUsuarios]
  )

  return {
    departamentos,
    departamentosOptions,
    hasDepartamentos: (departamentos ?? []).length > 0,
    loading
  }
}

export const useDepartamentosComunicados = () => {
  const { data: { departamentosComunicados = [] } = {}, isLoading: loading } =
    useQuery({
      queryKey: ['departamentosComunicados'],
      queryFn: async () =>
        await request<DepartamentosComunicadosQuery>(
          DEPARTAMENTOS_COMUNICADOS_QUERY
        )
    })

  const departamentosOptions = useMemo(
    () =>
      departamentosComunicados?.map(it => ({
        label: `[${it?.sigla}] ${it?.nome}`,
        value: it?.id,
        sigla: it?.sigla,
        assinatura: it?.assinatura
      })) as DepartamentoOption[],
    [departamentosComunicados]
  )

  return {
    departamentos: departamentosComunicados,
    departamentosOptions,
    loading
  }
}
